<template>
  <v-card>
    <v-card-title>
      <h2 v-if="match.featured">Featured Match</h2>
      <h2 v-else>Match | Rank {{ match.rank }}</h2>
    </v-card-title>
    <v-card-text>
      <p v-if="match.rank > 3" class="help ma-0">
        This would not show in the normal questionnaire results as its rank is higher than 3
      </p>
      <dl class="grid-wrapper">
        <dt>Organization</dt>
        <dd>
          <router-link
            class="default-btn link"
            :to="{
              name: 'OrganizationDashboard',
              params: { organizationId: match.product.organization.id }
            }">
            {{ match.product.organization.name }}
          </router-link>
        </dd>

        <dt>Product</dt>
        <dd>
          <router-link
            class="default-btn link"
            :to="{
              name: 'OrganizationProductsEdit',
              params: {
                organizationId: match.product.organization.id,
                productId: match.product.id,
              }
            }">
            {{ match.product.internalName || match.product.title }}
          </router-link>
        </dd>
      </dl>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CondensedMatchCard',
  props: {
    match: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  width: 100%;
}

.grid-wrapper {
  grid-template-columns: auto auto;
  justify-content: flex-start;
  grid-gap: 0 20px;
}

dt {
  font-weight: bold;
}
</style>
